import { AfterViewInit, Component, Input } from '@angular/core'
import { AttachPaymentMethodInterface, TilledBillingDetail } from '@mmx/shared'

declare let Tilled: any

@Component({
  selector: 'mmx-tilled-form',
  templateUrl: './tilled-form.component.html',
  styleUrls: ['./tilled-form.component.scss'],
  standalone: false,
})
export class TilledFormComponent implements AfterViewInit {
  @Input() tilledPublicKey: string | undefined
  @Input() tilledId: string | undefined
  @Input() tilledProductionMode = false

  get valid(): boolean {
    return this.tilledForm?.valid || false
  }

  private tilledComponent: any
  private tilledForm: any

  ngAfterViewInit(): void {
    this.loadTilled()
  }

  createPaymentMethod(billingDetail: TilledBillingDetail): Promise<AttachPaymentMethodInterface> {
    return this.tilledComponent.createPaymentMethod({
      form: this.tilledForm,
      billing_details: billingDetail,
    })
  }

  private async loadTilled() {
    this.tilledComponent = new Tilled(
      this.tilledPublicKey,
      this.tilledId,
      {
        sandbox: !this.tilledProductionMode,
      },
    )

    this.tilledForm = await this.tilledComponent.form({
      payment_method_type: 'card',
    })

    const fieldOptions = {
      styles: {
        base: {
          color: getComputedStyle(document.body)
            .getPropertyValue('color')
            .trim(),
          fontSize: '14px',
        },
        invalid: {
          color: getComputedStyle(document.body)
            .getPropertyValue('--warn-color')
            .trim(),
        },
      },
    }

    this.tilledForm
      .createField('cardNumber', {
        ...fieldOptions,
        placeholder: 'Card Number',
      })
      .inject('#card-number-element')

    this.tilledForm
      .createField('cardExpiry', { ...fieldOptions, placeholder: 'MM/YY' })
      .inject('#card-expiration-element')

    this.tilledForm
      .createField('cardCvv', {
        ...fieldOptions,
        placeholder: 'CVC',
      })
      .inject('#card-cvv-element')

    this.tilledForm.build()
  }
}
